import { DeviceInfo } from '@/shared/libs';
import { EventType } from '@/shared/enums';
import WindowInstanceMap from './window-instance-map';

const BREAKPOINTS = {
  MEDIUM: 576,
  SMALL_AD: 980,
  MOBILE: 1024,
  HD: 1366,
  FULL_HD: 1920,
};

export default ({ $EventBus }, inject) => {
  const window = new WindowInstanceMap({
    data() {
      return {
        focusTimeout: null,
        isIOSDevice: DeviceInfo.isIOS(),
        isMobileDevice: DeviceInfo.isMobile(),
        isKeyPressed: false,
      };
    },
    computed: {
      isMobileView() {
        return this.innerWidth < BREAKPOINTS.MOBILE;
      },
      isBelowHdView() {
        return this.innerWidth < BREAKPOINTS.HD;
      },
      isBelowFullHdView() {
        return this.innerWidth < BREAKPOINTS.FULL_HD;
      },
      isSmallAdView() {
        return this.innerWidth < BREAKPOINTS.SMALL_AD;
      },
      isMediumView() {
        return this.innerWidth < BREAKPOINTS.MEDIUM;
      },
    },
    created() {
      document.addEventListener('keydown', () => {
        this.isKeyPressed = true;
      });

      document.addEventListener('keyup', () => {
        this.isKeyPressed = false;
      });

      document.addEventListener('focusin', () => {
        if (this.focusTimeout) {
          clearTimeout(this.focusTimeout);
          this.focusTimeout = null;
          return;
        }

        if (this.isKeyPressed) {
          $EventBus.emit(EventType.ACCESSIBILITY_BODY_BLUR);
        }
      });

      document.addEventListener('focusout', () => {
        this.focusTimeout = setTimeout(() => {
          this.focusTimeout = null;

          if (this.isKeyPressed) {
            $EventBus.emit(EventType.ACCESSIBILITY_BODY_FOCUS);
          }
        }, 0);
      });
    },
    methods: {
      isBodyFocused() {
        return document.activeElement === document.body;
      },
    },
  });

  inject('window', window);
};
